import { GraphQLClient } from "graphql-request";
import { API_URL } from "./Constant";

export const graphQlClient = () => new GraphQLClient(`${API_URL}/graphql`);

export const baseApiUrl = `${API_URL}/graphql`;
